(() => {
  const selector = '[data-irp-home-hero]';

  class IrpHomeHeroSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-irp-home-hero-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-irp-home-hero-dot]'));
      this.status = root.querySelector('[data-irp-home-hero-status]');
      this.delay = Math.max(Number(root.dataset.delay) || 7000, 5000);
      this.autoplay = root.dataset.autoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.timer = null;
      this.paused = !this.autoplay || this.reducedMotion.matches;
      this.abortController = new AbortController();

      if (this.slides.length < 2) return;

      this.bind();
      this.update(0, false);
      this.schedule();
    }

    bind() {
      const options = { signal: this.abortController.signal };
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.move(Number(dot.dataset.irpHomeHeroDot), true), options));

      this.root.addEventListener('keydown', (event) => {
        if (event.target.closest('a, button, input, select, textarea')) return;
        if (event.key === 'ArrowLeft') this.move(this.index - 1, true);
        if (event.key === 'ArrowRight') this.move(this.index + 1, true);
      }, options);

      this.root.addEventListener('focusin', () => this.clearTimer(), options);
      this.root.addEventListener('focusout', () => window.setTimeout(() => {
        if (!this.root.contains(document.activeElement)) this.schedule();
      }, 0), options);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.clearTimer();
        else this.schedule();
      }, options);

      this.reducedMotion.addEventListener('change', (event) => {
        this.setPaused(event.matches || !this.autoplay);
      }, options);
    }

    move(nextIndex, announce = false) {
      const normalized = (nextIndex + this.slides.length) % this.slides.length;
      this.update(normalized, announce);
      this.schedule();
    }

    update(nextIndex, announce) {
      this.index = nextIndex;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
      if (announce && this.status) this.status.textContent = `Diapositiva ${this.index + 1} de ${this.slides.length}`;
    }

    setPaused(paused) {
      this.paused = paused;
      if (paused) this.clearTimer();
      else this.schedule();
    }

    schedule() {
      this.clearTimer();
      if (this.paused || !this.autoplay || document.hidden || this.slides.length < 2) return;
      this.timer = window.setTimeout(() => {
        this.update((this.index + 1) % this.slides.length, false);
        this.schedule();
      }, this.delay);
    }

    clearTimer() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
    }

    destroy() {
      this.clearTimer();
      this.abortController.abort();
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll(selector).forEach((root) => {
      if (root.irpHomeHeroSlider) return;
      root.irpHomeHeroSlider = new IrpHomeHeroSlider(root);
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector(selector);
    root?.irpHomeHeroSlider?.destroy();
  });
})();
